import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import saveAs from 'file-saver';
import Papa from 'papaparse';
import { BaseButtonProps } from 'antd/lib/button/button';
import { useImportContext } from './ImportProvider';

type ImportDownloadTemplateButtonProps = BaseButtonProps & {
    templateName?: string;
};

export const ImportDownloadTemplateButton = ({ children, templateName, ...buttonProps }: ImportDownloadTemplateButtonProps) => {
    const { csvConfig } = useImportContext();
    const columns = csvConfig.map(it => it.column);

    return (
        <Tooltip title="Download the CSV template and fill it in with your data to import.">
            <Button type="text" onClick={() => downloadTemplate(columns, templateName)} {...buttonProps}>
                {children ? children : 'Download Template'}
            </Button>
        </Tooltip>
    );
};

function downloadTemplate(csvColumns: string[], templateName: string = 'import-template') {
    const csvData = Papa.unparse([csvColumns], {
        quotes: true,
        quoteChar: '"',
        escapeChar: '"',
        delimiter: ',',
        header: true,
        escapeFormulae: true,
    });
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, `${templateName}.csv`);
}
